<script setup lang="ts">
import type { Component } from 'vue';
import type { FormFragment } from '@pkg/sanity-utils/types/forms';
import FormsBlock from './FormsBlock.vue';

defineProps<{
  block?: {
    _type: string;
    _key: string;
    anchorId?: string;
    form?: FormFragment;
  };
  config: {};
  modularRenderer: Component;
}>();
</script>

<template>
  <FormsBlock
    v-if="block?.form?.fields && block?.form?.fields?.length > 0"
    :id="block?.anchorId"
    :form="block?.form"
    :modular-renderer="modularRenderer"
  />
</template>
